<!--
 * @Description: financingEvent
 * @Author: lz
 * @Date: 2021-07-20 13:42:25
 * @LastEditTime: 2021-10-13 09:55:39
 * @LastEditors: lz
-->
<template>
  <div class="financingEvent">
    <div class="t">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="融资事件" key="financingEvent"></a-tab-pane>
      </a-tabs>
      <!-- <div class="city">
        <span>所在地区：</span>
        <a-cascader :field-names="{
            label: 'name',
            value: 'id',
            children: 'children',
          }" :options="listTreeCityList" @change="onListTreeCityChange" :disable="true">
          <a-button type="link" style="height: 24px" class="padding-none">
            {{ listTreeCityText }}
            <a-icon type="caret-down" />
          </a-button>
        </a-cascader>
      </div> -->
      <div class="filter_item" :class="{ policyArea_more: !isBusinessArea }">
        <span class="title">业务领域：</span>
        <div>
          <span class="option_item" @click="changeBusinessArea(item)" :class="{ active: BusinessArea_active == item.id}" v-for="(item, index) in BusinessArea" :key="index + 'BusinessArea'">
            {{ item.name }}
          </span>
        </div>
        <a-button type="link" v-show="!isBusinessArea" @click="isBusinessArea = !isBusinessArea">
          更多
          <a-icon type="down" />
        </a-button>
        <a-button type="link" v-show="isBusinessArea" @click="isBusinessArea = !isBusinessArea">
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isPolicyArea }">
        <span class="title">融资轮次：</span>
        <div>
          <span class="option_item" @click="changePolicyArea(item)" :class="{ active: policyArea_active == item.id }" v-for="(item, index) in policyArea" :key="index + 'policyArea'">
            {{ item.name }}
          </span>
        </div>
        <a-button type="link" v-show="!isPolicyArea" @click="isPolicyArea = !isPolicyArea">
          更多
          <a-icon type="down" />
        </a-button>
        <a-button type="link" v-show="isPolicyArea" @click="isPolicyArea = !isPolicyArea">
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <!-- <div class="filter_item" :class="{ policyArea_more: !isbusinessOptimization }">
        <span class="title">招商优选：</span>
        <div>
          <span class="option_item" @click="changebusinessOptimization(item)" :class="{ active: businessOptimization_active == item.id }" v-for="(item, index) in businessOptimization" :key="index + 'businessOptimization'">
            {{ item.name }}
          </span>
        </div>
        <a-button type="link" v-show="!isbusinessOptimization" @click="isbusinessOptimization = !isbusinessOptimization">
          更多
          <a-icon type="down" />
        </a-button>
        <a-button type="link" v-show="isbusinessOptimization" @click="isbusinessOptimization = !isbusinessOptimization">
          收起
          <a-icon type="up" />
        </a-button>
      </div> -->
      <div class="filter_item" style="display:block;margin-bottom: 15px;">
        <span>融资时间：</span>
        <a-range-picker @change="onChange" />
      </div>
      <div class="filter_item" style="display:block;">
        <span>关键词：</span>
        <input type="text" class="search" v-model="filterList.keyword" @keyup.enter="search" placeholder="请输入政策关键词，如高新技术企业" />
        <svg-icon icon-class="search1" class="search_icon" @click.native="search"></svg-icon>
      </div>
    </div>
    <div class="line"></div>
    <div class="b" id="b">
      <div class="table">
        <a-table :loading="loading" row-key="index" :scroll="{ y: tableHeight }" :columns="columns" :data-source="tableData" :pagination="{
            pageSize: filterList.pageSize,
            current: filterList.pageNum,
            total: filterList.total,
            showQuickJumper: true, //显示跳转页数
            showSizeChanger: true, // 显示可改变每页数量
            pageSizeOptions: ['10', '20'], // 每页数量选项
            showTotal: (total) => `共 ${filterList.total} 条`, //显示总数
          }" @change="showSizeChange">
          <div slot="investors" slot-scope="text" style="padding-top:10px;">
            <template v-if="text.length">
              <div class="investors" :class="{'disabled':item.orgFullName == null}" v-for="item in text" :key="item.orgId" @click="goDetail(item.orgFullName)">{{item.orgName}}</div>
            </template>
            <template v-else>
              <div class="investors disabled">未透露</div>
            </template>
          </div>
          <div slot="financingAmount" slot-scope="text,record">
            <span v-if="text && record.currencyName">{{text + record.currencyName}}</span>
            <span v-else class="disabled">未透露</span>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { listTreeCityOnlyBeijing } from "@/api/policyDocuments";
import {
  getBusinessArea,
  getBusinessCount,
  getOptimization,
  getRzList
} from "@/api/financingEvent";

const columns = [
  {
    title: "企业信息",
    dataIndex: "companyName",
    key: "companyName",
    scopedSlots: { customRender: "companyName" }
  },
  {
    title: "业务领域",
    dataIndex: "businessArea",
    key: "businessArea",
    ellipsis: true,
    scopedSlots: { customRender: "businessArea" }
  },
  {
    title: "融资金额",
    dataIndex: "financingAmount",
    key: "financingAmount",
    ellipsis: true,
    scopedSlots: { customRender: "financingAmount" }
  },
  {
    title: "融资轮次",
    dataIndex: "financingRound",
    key: "financingRound",
    ellipsis: true,
    scopedSlots: { customRender: "financingRound" }
  },
  {
    title: "融资时间",
    dataIndex: "financeDate",
    key: "financeDate",
    ellipsis: true,
    scopedSlots: { customRender: "financeDate" }
  },
  {
    title: "投资方",
    dataIndex: "investors",
    key: "investors",
    ellipsis: true,
    scopedSlots: { customRender: "investors" }
  }
];

export default {
  name: "FinancingEvent",
  data() {
    return {
      tableHeight: 360,
      tableData: [],
      treeCityList: [],
      listTreeCityObj: {
        name: "",
        id: ""
      },
      columns,
      activeName: "financingEvent",
      loading: false,
      isPolicyArea: false,
      isBusinessArea: false,
      isbusinessOptimization: false,
      filterList: {
        beginTime: "",
        businessScope: "",
        endTime: "",
        financingRounds: "",
        keyword: "",
        optimization: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      policyArea: [],
      policyArea_active: "",
      BusinessArea: [],
      BusinessArea_active: [],
      businessOptimization: [],
      businessOptimization_active: "",
      listTreeCityList: [],
      area: null
    };
  },
  computed: {
    listTreeCityText() {
      let text;
      this.listTreeCityList.forEach(n => {
        if (n.id == this.area) {
          text = n.name;
        } else {
          if (n.children) {
            n.children.forEach(m => {
              if (m.id == this.area) {
                text = m.name;
              }
            });
          }
        }
      });
      return text;
    }
  },
  methods: {
    goDetail(orgFullName) {
      if (orgFullName) {
        this.$router.push("/financingEventDetail?orgName=" + orgFullName);
      }
    },
    async init() {
      const city = await listTreeCityOnlyBeijing();
      this.listTreeCityList = city.data.treeList || [];
      this.area = city.data.currentArea.cityCode;
    },
    onChange(date, dateString) {
      this.filterList.beginTime = dateString[0];
      this.filterList.endTime = dateString[1];
      this.search();
    },
    //融资轮次
    changePolicyArea(item) {
      this.filterList.financingRounds = this.policyArea_active = item.id;
      this.search();
    },
    //业务领域
    changeBusinessArea(item) {
      // 原来多选的逻辑
      // if (!item.id) {
      //   this.filterList.businessScope = [];
      // } else {
      //   if (this.filterList.businessScope.includes(item.id)) {
      //     let index = this.filterList.businessScope.indexOf(item.id);
      //     this.filterList.businessScope.splice(index, 1);
      //   } else {
      //     this.filterList.businessScope.push(item.id);
      //   }
      //   this.filterList.businessScope.filter(n => n != item.id);
      // }
      // this.BusinessArea_active = [...this.filterList.businessScope];
      this.filterList.businessScope = this.BusinessArea_active = item.id;
      this.search();
    },
    //招商优选
    changebusinessOptimization(item) {
      this.filterList.optimization = this.businessOptimization_active = item.id;
      this.search();
    },
    //选择所在地区
    onListTreeCityChange(v) {
      // const targetOption = selectedOptions[selectedOptions.length - 1];
      // this.getListPolicyAreasData(targetOption);
      this.area = v[v.length - 1];
      this.search();
    },
    // getArr(obj) {
    //   let arr = [{ id: "", name: "全部" }];
    //   for (const key in obj) {
    //     if (Object.hasOwnProperty.call(obj, key)) {
    //       const el = obj[key];
    //       arr.push({
    //         id: key,
    //         name: el,
    //       });
    //     }
    //   }
    //   return arr;
    // },
    search() {
      this.filterList.pageNum = 1;
      this.getTableData();
    },
    // async getListPolicyAreasData(obj) {
    //   this.listTreeCityObj = obj;
    //   this.filterList.areaCode = obj.id;
    //   const listPolicyAreasListData = await listPolicyAreasList({
    //     cityCode: "",
    //     currentAreaCode: obj.id
    //   });
    //   this.policyArea = this.getArr(listPolicyAreasListData.data.policyArea);
    //   this.businessOptimization = this.getArr(
    //     listPolicyAreasListData.data.receivingDept
    //   );
    //   await this.getTableData();
    // },
    async getTableData() {
      this.loading = true;
      try {
        const {
          keyword,
          beginTime,
          endTime,
          pageNum,
          pageSize,
          optimization,
          businessScope,
          financingRounds
        } = this.filterList;
        const res = await getRzList({
          keyword,
          beginTime,
          endTime,
          pageNum,
          pageSize,
          optimization,
          businessScope,
          financingRounds
          // area: this.area
        });
        this.loading = false;
        this.filterList.total = res.data.total || 0;
        this.tableData = res.data.list || [];
        let index = 1;
        this.tableData = this.tableData.map(n => {
          n.index = index++;
          return n;
        });

        const copyData = this.tableData.filter(n => n.companyName);
        this.tableData = [...copyData];
        // if (pageNum === 1) {
        //   this.tableData.unshift({
        //     IdentityId: new Date().toLocaleTimeString(),
        //     Title: "下面对不齐是符号问题",
        //     Dept: "是的归属感颂德歌功问题十",
        //     PublishTime: new Date()
        //       .toLocaleDateString()
        //       .replaceAll("/", "-")
        //       .split("-")
        //       .map(el => {
        //         return el.padStart(2, 0);
        //       })
        //       .join("-"),
        //     tag: true
        //   });
        // }
      } catch (error) {
        this.loading = false;
      }
    },
    showSizeChange({ current, pageSize }) {
      this.filterList.pageSize = pageSize;
      this.filterList.pageNum = current;
      this.getTableData();
    },
    async pageInit() {
      // const listTreeCityData = await listTreeCityOnlyBeijing();
      // this.treeCityList = listTreeCityData.data.treeList;
      listTreeCityOnlyBeijing().then(res => {
        const listTreeCityData = res;
        this.treeCityList = listTreeCityData.data.treeList;
      });
      //业务领域
      getBusinessArea().then(res => {
        const BusinessArea = res;
        this.BusinessArea = BusinessArea.data;
        this.BusinessArea.unshift({ id: "", name: "全部" });
      });

      //融资轮次
      getBusinessCount().then(res => {
        const policyArea = res;
        this.policyArea = policyArea.data;
        this.policyArea.unshift({ id: "", name: "全部" });
      });
      //招商优选
      getOptimization().then(res => {
        const businessOptimization = res;
        this.businessOptimization = businessOptimization.data;
        this.businessOptimization.unshift({ id: "", name: "全部" });
      });
      this.getTableData();
    },
    getTableHeight() {
      let timer;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.tableHeight =
          document.documentElement.clientHeight -
          document.getElementById("b").offsetTop -
          165;
      }, 60);
    }
  },
  created() {
    this.init();
    this.pageInit();
    this.$nextTick(() => {
      this.getTableHeight();
    });
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.$once("hook:destroyed", () => {
      window.removeEventListener("resize", this.getTableHeight);
    });
  }
};
</script>
<style lang="less" scoped>
@bgColor: #fff;
.padding_none {
  padding: 0;
}
.text_tag {
  color: red;
}
.line {
  height: 10px;
  width: auto;
  background: #eff2f5;
}
.cursor {
  cursor: pointer;
}
.financingEvent {
  height: 100%;
  // padding: 10px;
  .t {
    background-color: @bgColor;
    padding: 12px 20px 20px 20px;
  }
  .line {
    height: 10px;
    background: #eff2f5;
  }
  .b {
    background-color: @bgColor;
    padding: 20px 20px 0 20px;
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .table {
      .table_wrapper {
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 20px;
        .image {
          width: 150px;
          height: 150px;
          border: 1px solirgb(24, 23, 23) f4;
          margin-right: 20px;
        }
        .info {
          width: 520px;
          .title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-bottom: 24px;
          }
          .detail {
            margin-bottom: 14px;

            &.flex {
              display: flex;
              span {
                text-align: left;
                width: 50%;
              }
            }
          }
        }
      }

      .date {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  ::v-deep .ant-table-pagination.ant-pagination {
    margin-bottom: 5px;
  }
  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 0 0 12px 0;
  }
  ::v-deep .ant-tabs-ink-bar {
    width: 64px;
    background-color: #0072f7;
  }
  .city {
    margin-bottom: 26px;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    .ant-btn {
      color: #0072f7;
      height: 14px;
      line-height: 14px;
      padding: 0;
    }
  }
  .filter_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
    ::v-deep .ant-calendar-picker-input {
      width: 300px;
      border-radius: 2px;
      border: 1px solid #e0e0e0;
    }
    .search {
      width: 300px;
      height: 32px;
      padding-left: 10px;
      padding-right: 28px;
      margin-left: 14px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e0e0e0;
      font-size: 14px;
      font-weight: 400;
      outline: none;
    }
    .search_icon {
      width: 14px;
      height: 14px;
      margin-top: 9px;
      margin-left: -28px;
      color: #0072f7;
      cursor: pointer;
    }
    &.policyArea_more {
      height: 24px;
      margin-bottom: 15px;
      overflow: hidden;
    }
    .title {
      width: 70px;
      line-height: 24px;
    }
    div {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .option_item {
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0px 10px;
        cursor: pointer;
        //min-width: 76px;
        text-align: center;
      }
    }
    ::v-deep .ant-btn > .anticon + span,
    .ant-btn > span + .anticon {
      margin-left: 4px;
    }
    .ant-btn-link {
      color: #0072f7;
    }
    ::v-deep .ant-btn {
      color: #999;
      width: 80px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
    // span:nth-child(2) {
    //   margin-left: 10px;
    // }
    .more {
      // float: right;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      cursor: pointer;
    }
    .more::after {
      content: "";
      display: inline-block;
      width: 7px;
      height: 7px;
      margin-left: 5px;
      transform: rotate(45deg);
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      vertical-align: 2px;
    }
    .active {
      height: 24px;
      line-height: 24px;
      background: #0072f7;
      border-radius: 4px;
      color: @bgColor;
    }
  }
}
::v-deep .ant-table-thead > tr > th {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 14px;
  padding: 12px 16px;
}
::v-deep .ant-table-tbody > tr > td {
  padding: 14px 16px;
}

::v-deep .ant-table-thead > tr > th,
::v-deep .ant-table-fixed .ant-table-thead > tr > th {
  padding: 0 16px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang SC, PingFangSC-Regular;
  font-weight: 500;
  color: #333333;
}
::v-deep .ant-table-tbody > tr > td,
::v-deep .ant-table-fixed .ant-table-tbody > tr > td {
  padding: 0 16px;
  font-size: 14px;
  font-family: PingFang SC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
  height: 50px;
}
.investors {
  color: #0072f7;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover {
    color: rgba(0, 114, 247, 0.7);
  }
}
.disabled {
  color: #999;
  &:hover {
    color: #999;
  }
}
input::input-placeholder {
  color: #bfbfbf;
}
input::-webkit-input-placeholder {
  //兼容WebKit browsers（Chrome的内核）
  color: #bfbfbf;
}
input::-moz-placeholder {
  //Mozilla Firefox 4 to 18
  color: #bfbfbf;
}
input::-moz-placeholder {
  //Mozilla Firefox 19+
  color: #bfbfbf;
}
input::-ms-input-placeholder {
  //Internet Explorer 10+
  color: #bfbfbf;
}
</style>